/* Post-production pills select only their assigned video; unassigned pills stay disabled. */
(() => {
  if (customElements.get('cp-post-player')) return;
  class CpPostPlayer extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-post-key]');
        if (!button || button.disabled || button.getAttribute('aria-pressed') === 'true') return;
        this.select(button.dataset.postKey);
      }, { signal: this.ac.signal });
      document.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-post-panel]');
        if (panel && this.contains(panel)) this.select(panel.dataset.postPanel);
      }, { signal: this.ac.signal });
    }
    select(key) {
      const panels = [...this.querySelectorAll('[data-post-panel]')];
      if (!panels.some((panel) => panel.dataset.postPanel === key)) return;
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.postPanel !== key;
        if (panel.hidden) panel.querySelectorAll('video').forEach((video) => video.pause());
      });
      this.querySelectorAll('[data-post-key]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.postKey === key));
      });
      // The shared cs-video observer starts the selected clip only when visible.
    }
    disconnectedCallback() { this.ac?.abort(); }
  }
  customElements.define('cp-post-player', CpPostPlayer);
})();
